import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { GlobalContext } from "../../context/GlobalContext";
import { validateAuctionOtp, resendAuctionOtp, confirmIdAndNationalityUpdate } from "../../api/api";
import Modal from '../Modal';
import $ from "jquery";

class AbsherOtp extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      profileMobileNumber: '',
      activationCode: '',
      serviceRequestID: '',
      errors: {},
      openModalFlag: false,
      loading: false,
      otpType: '',
      orderId: '',
      hashcode: ''
    }
  }

  componentDidMount = () => {
    const [context] = this.context;
    this.setState({
      profileMobileNumber: context.mobileNum,
      otpType: context.otpType,
      orderId: context.orderId,
      hashcode: context.hashCode,
      serviceRequestID: context.serviceRequestID
    })
  }

  handleOtpChange = (evt) => {
    const re = /^[0-9\b]+$/;
    if (evt.target.value === "" || re.test(evt.target.value)) {
      this.setState({
        activationCode: evt.target.value,
      });
    }
  };

  profileValidateForm() {
    let errors = {};
    let formIsValid = true;

    if (!this.state.activationCode) {
      formIsValid = false;
      errors["profileUpdate_pin_code"] = "pin_code_required";
    }
    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (this.profileValidateForm()) {
      const { activationCode, serviceRequestID, hashcode } = this.state;
      const validateAuctionOtpResult = await validateAuctionOtp(activationCode, serviceRequestID);

      if (validateAuctionOtpResult?.status === 204) {
        const confirmIdAndNationalityResult = await confirmIdAndNationalityUpdate(hashcode)
        const { data } = confirmIdAndNationalityResult

        if (data.status.code === "MAPI-000") {
         $("#formLogin").attr("action", window.loginURL).submit();
        }
        else {
          let errors = {};
          errors["customError"] = "invalid_data";
          this.setState({
            errors: errors,
          });
        }
      }
      else {
        let errors = {};
        errors["customError"] = "invalid_data";
        this.setState({
          errors: errors,
          loading: false,
          openModalFlag: true
        });
      }
    }
  }

  handleResendCode = async (e) => {
    e.preventDefault();
    const { serviceRequestID, orderId } = this.state;
    await resendAuctionOtp(serviceRequestID, orderId);

    this.setState({
      openModalFlag: false,
    })
  }

  handleClose = () => {
    this.setState({
      openModalFlag: false,
    })
  }

  render() {
    const { t } = this.props;
    const { openModalFlag, errors } = this.state
    return (
      <>
        {openModalFlag && <Modal openModalFlag={openModalFlag} handleSendNow={this.handleResendCode} handleClose={this.handleClose} />}

        <div className="pu_subheading">{t("absher_verification_code_text")}</div>

        <div className={"form-group " + (errors.profileUpdate_pin_code ? "not-valid" : "")}>
          <input
            type="text"
            className="form-control pu-activation-code"
            placeholder={t("profileUpdate_pin_code")}
            pattern="[0-9]*"
            maxLength="4"
            value={this.state.activationCode}
            onChange={this.handleOtpChange}
          />

          {errors.profileUpdate_pin_code ? (
            <div className="alert alert-danger" role="alert">
              {t(errors.profileUpdate_pin_code)}{" "}
              <i
                className="fa fa-exclamation-circle"
                aria-hidden="true"
              ></i>
            </div>
          ) : (
            <div className="empty-alert">&nbsp;</div>
          )}
        </div>

        <div className="popup2_open login-resendCode-btn" onClick={(e) => this.handleResendCode(e)}> {t("resendTheCode")} </div>
        <button
          onClick={this.handleOtpSubmit}
          type="submit mu"
          name="confirm_button"
          className="btn min_outlin_btn active">
          {t("verify_code")}{" "}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </>
    )
  }
}

export default withTranslation()(AbsherOtp);